import * as CubeTree from '../../cubeTree/index';
import FrontCubeData from '../../frontCubeData/index';
import CodiSystem from '../../codiSystem/index';
import { cubeModify } from '../../update/cubeModify';
import { __add__, __clear__, __clearShortLink__, __getLinks__ } from './db';
import { createLink } from './link';
import { renderLinkStyle } from './style';
import { clearGroupList } from './clearGroupList';

function init(): void {
    let stage: CubeId = CubeTree.findSketchpad();
    let groupListStr: string = FrontCubeData.getValue(stage, 'moduleGroups') || '[]';
    let groupList: CubeId[][] = JSON.parse(groupListStr);

    updateGroupKey(groupList);
    groupList = clearGroupList(groupList);
    __clear__();
    groupList.forEach((cubeIds: CubeId[]): void => {
        let sortIds: CubeId[] = CodiSystem.sortByLeft(cubeIds);
        let link: LinkedListInstance = createLink(sortIds);

        __add__(link);
    });
    __clearShortLink__();
    renderLinkStyle(__getLinks__());
}

// 处理历史数据
function updateGroupKey(groupList: CubeId[][]): void {
    let partitions: CubeId[] = CubeTree.findAllPartitions();

    partitions.forEach((layer: CubeId): void => {
        let linked: boolean = layerIsLinked(layer, groupList);

        cubeModify(layer, {
            grouped: linked ? 1 : 0
        });
    });
}

function layerIsLinked(layer: CubeId, groupList: CubeId[][]): boolean {
    for(let i = 0; i < groupList.length; i++) {
        let link: CubeId[] = groupList[i];

        if (link.includes(layer)) {
            return true;
        }
    }

    return false;
}

export {
    init
};
